'use strict';
const ensureElementIfNeeded = require('./util/ensure-element-if-needed');
module.exports = function applyLabel(decorationsElement, label) {
	const shouldBeShown = (label || label === 0),
		element = ensureElementIfNeeded(decorationsElement, 'span', '.mapjs-label', shouldBeShown, {class: 'mapjs-label'});
	if (shouldBeShown) {
		element.innerText = label;
	}
	return element;
};
